import { Button, EButtonColorVariant } from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import MaxWidth from '@/components/common/layout/MaxWidth';
import SupportImage from '@/components/icons/Support.svg';

import css from './ContactSupport.module.css';

const ContactSupport = () => {
  const intl = useIntl();

  return (
    <MaxWidth className={`mt-2 mb-6 w-full md:w-1/2`}>
      <div className={`${css.maxCharacterCount} mx-auto w-full`}>
        <div className="flex">
          <div className="w-24 h-full">
            <SupportImage />
          </div>
          <div>
            <div className="text-3xl font-medium">
              <FormattedMessage defaultMessage="More questions?" id="hcc4LQ" />
            </div>
            <p>
              <FormattedMessage
                defaultMessage="No problem, we're always happy to help. Contact Support Read more at:"
                id="qsTPTb"
              />
            </p>
            <Button
              className="max-w-sm mt-4"
              href="mailto:support@outdoorsy.com"
              variant={EButtonColorVariant.Primary}
              label={intl.formatMessage({ defaultMessage: 'Contact Support', id: 'YdQxfw' })}
            />
          </div>
        </div>
      </div>
    </MaxWidth>
  );
};

export default ContactSupport;
